import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { BreadCrumb } from '../../common/breadcrumb';
import api from '../../../services/axios';
import Swal from "sweetalert2";
import { useJWTAuth } from '../../../services/JWTAuthProvider';
import { userRole } from '../../../constants/appConst';

export const EditUser = (props) => {
    const { user } = useJWTAuth();
    const userInfo = user;
    const navigate = useNavigate();
    //const [selectedDropdownItem, setSelectedDropdownItem] = useState('');
    const location = useLocation();
    const { email: emailFromState, name: nameFromState, role: roleFromState, userIdentifier: identifierfromState, isssologin: ssoFromState } = location.state || { email: '', name: '', role: '', userIdentifier: '', isssologin: '' };
    const [email] = useState(emailFromState);
    const [name, setName] = useState(nameFromState);
    //const [role, setRole] = useState(roleFromState);
    const [userIdentifier] = useState(identifierfromState);
    const [subBtnDisabled, setSubBtnDisabled] = useState(false);
    const [formValues, setFormValues] = useState({
        name: '',
        id: '',
        password: '',
        confirm: '',
    });
    const [formErrors, setFormErrors] = useState({
        name: '',
        id: '',
        password: '',
        confirm: '',
        folders: ''
    });
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [passwordMatchError, setPasswordMatchError] = useState(false);
    const [nameRegexError, setNameRegexError] = useState(false);
    const [nameRequiredError, setnameRequiredError] = useState(false);
    //const [roleSelection, setRoleSelection] = useState('');
    const [selectedFolders, setSelectedFolders] = useState([]);
    const [folderRoles, setFolderRoles] = useState([]);
    const [bulkRole, setBulkRole] = useState(0);
    const [selectFolderError, setFolderError] = useState(false);
    const [isGlobalAdmin, setIsGlobalAdmin] = useState(false);

    // Fixed missing label for role 4
    // const roleMapping = {
    //     1: "GlobalAdmin",
    //     2: "BusinessUnitAdmin",
    //     3: "BusinessUnitUser",
    //     4: "BusinessUnitUserAdministrator" 
    // };

    // Added Role Hierarchy Logic
    const getRoleLevel = (currentRole) => {
        switch (currentRole) {
            case userRole.GlobalAdmin:
                return 100;
            case userRole.BusinessUnitAdmin:
                return 80;
            case userRole.BusinessUnitUserAdministrator:
                return 50;
            case userRole.BusinessUnitUser:
                return 10;
            default:
                console.warn("Role not matched in getRoleLevel! Raw value:", currentRole);
                return 0;
        }
    };

    const roleOptions = [
        { id: 1, label: "GlobalAdmin", minLevelRequired: 100 },
        { id: 2, label: "BusinessUnitAdmin", minLevelRequired: 80 },
        { id: 4, label: "BusinessUnitUserAdministrator", minLevelRequired: 50 },
        { id: 3, label: "BusinessUnitUser", minLevelRequired: 50 }
    ];

    //const currentUserLevel = getRoleLevel(user.role);
    // const highestRole = user?.isGlobalAdmin
    //     ? userRole.GlobalAdmin
    //     : Math.min(...(user?.folders ?? []).map(f => f.role));

    // const getCurrentUserRole = () => {

    //     if (user?.isGlobalAdmin)
    //         return userRole.GlobalAdmin;

    //     if (!user?.folders?.length)
    //         return 0;

    //     return user.folders.reduce(
    //         (highest, folder) => folder.role < highest ? folder.role : highest,
    //         userRole.BusinessUnitUser
    //     );
    // };

    //     const getCurrentUserRole = () => {

    //     console.log("Full user object:", user);
    //     console.log("Folders:", user?.folders);

    //     if (user?.isGlobalAdmin) {
    //         console.log("Global Admin");
    //         return userRole.GlobalAdmin;
    //     }

    //     if (!user?.folders?.length) {
    //         console.log("No folders");
    //         return 0;
    //     }

    //     const roles = user.folders.map(f => f.role);

    //     console.log("Folder roles:", roles);

    //     const minRole = Math.min(...roles);

    //     console.log("Computed role:", minRole);

    //     return minRole;
    // };


    const getCurrentFolderRole = (folderId) => {

        if (user?.isGlobalAdmin)
            return userRole.GlobalAdmin;

        const folder = user?.folders?.find(
            x =>
                x.folderIdentifier?.toLowerCase() ===
                folderId?.toLowerCase()
        );

        return folder?.role ?? 0;
    };

    const bulkVisibleRoles = (() => {

        if (user?.isGlobalAdmin)
            return roleOptions;

        const roles = user.folders.map(f => f.role);

        const highest = Math.min(...roles);

        switch (highest) {

            case userRole.BusinessUnitAdmin:
                return roleOptions.filter(r => [2, 3, 4].includes(r.id));

            case userRole.BusinessUnitUserAdministrator:
                return roleOptions.filter(r => [3, 4].includes(r.id));

            default:
                return [];
        }

    })();

    //const currentUserLevel = getRoleLevel(getCurrentUserRole());

    //const currentUserLevel = getRoleLevel(highestRole);



    // const visibleRoles =
    //     roleOptions.filter(role =>
    //         currentUserLevel >= role.minLevelRequired
    //     );
    //         console.log({
    // currentUserRole: getCurrentUserRole(),
    // currentUserLevel,
    // visibleRoles,
    // bulkRole
    // });

    const getVisibleRoles = (folderId) => {

        const role = getCurrentFolderRole(folderId);

        switch (role) {

            case userRole.GlobalAdmin:
                return roleOptions;

            case userRole.BusinessUnitAdmin:
                return roleOptions.filter(r =>
                    [2, 3, 4].includes(r.id));

            case userRole.BusinessUnitUserAdministrator:
                return roleOptions.filter(r =>
                    [3, 4].includes(r.id));

            case userRole.BusinessUnitUser:
                return roleOptions.filter(r =>
                    r.id === 3);

            default:
                return [];
        }
    };

    console.log("userRole enum", userRole);
    console.log(user.folders);

    const getRoleSummary = (role) => {

        switch (role) {
            case 1:

                return (
                    <>
                        <div className="fw-bold text-primary">
                            Global Admin
                        </div>

                        <small>✓ Full System Access</small><br />
                        <small>✓ All Folders</small><br />
                        <small>✓ User Management</small><br />
                        <small>✓ Content Management</small>
                    </>
                );

            case 2:
                return (
                    <>
                        <div className="fw-bold text-primary">
                            BusinessUnitAdmin
                        </div>

                        <small>✓ Content : View</small><br />
                        <small>✓ Content : Add/Edit/Delete</small><br />
                        <small>✓ User : Add/Edit/Delete</small>
                    </>
                );

            case 3:
                return (
                    <>
                        <div className="fw-bold text-primary">
                            BusinessUnitUser
                        </div>

                        <small>✓ Content : View</small><br />
                        <small>✗ Content : Add/Edit/Delete</small><br />
                        <small>✗ User : Add/Edit/Delete</small>
                    </>
                );

            case 4:
                return (
                    <>
                        <div className="fw-bold text-primary">
                            BusinessUnitUserAdministrator
                        </div>

                        <small>✓ Content : View</small><br />
                        <small>✗ Content : Add/Edit/Delete</small><br />
                        <small>✓ User : Add/Edit/Delete</small>
                    </>
                );

            default:
                return (
                    <span className="text-danger">
                        No Access
                    </span>
                );
        }

    };


    // const roleOptions = [
    //     { id: 1, label: "GlobalAdmin", minLevelRequired: 100 },
    //     { id: 2, label: "BusinessUnitAdmin", minLevelRequired: 80 },
    //     { id: 4, label: "BusinessUnitUserAdministrator", minLevelRequired: 50 },
    //     { id: 3, label: "BusinessUnitUser", minLevelRequired: 50 } 
    // ];

    // Filter the options so the user only sees roles at or below their own level
    //const visibleRoles = roleOptions.filter(role => currentUserLevel >= role.minLevelRequired);


    // const handleDropdownItemClick = (number) => {
    //     setSelectedDropdownItem(roleMapping[number]);
    //     if (number === 1) {
    //         setFolderError(false);
    //         setSubBtnDisabled(false)
    //     }
    //     setRoleSelection(number);
    // };


    const handleclose = () => {
        navigate('/UserManagement');
    }
    // const handleFolderRoleChange = (folderId, role) => {
    //     setFolderRoles(prev =>
    //         prev.map(item =>
    //             item.folderId === folderId
    //                 ? { ...item, role }
    //                 : item
    //         )
    //     );

    // };
    // const handleFolderRoleChange = (folderId, role) => {

    //     const creatorRole = getCurrentFolderRole(folderId);

    //     if (role !== 0 && role < creatorRole)
    //         role = creatorRole;

    //     setFolderRoles(prev =>
    //         prev.map(item =>
    //             item.folderId === folderId
    //                 ? { ...item, role }
    //                 : item
    //         )
    //     );
    // };
    const handleFolderRoleChange = async (folderId, role) => {

    if (role === userRole.GlobalAdmin) {

        const result = await Swal.fire({
            title: "Global Admin Access",
            text: "Selecting Global Admin will automatically grant access to all folders/sites. Do you want to continue?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            reverseButtons: true
        });

        if (!result.isConfirmed) {
            return;
        }

        setIsGlobalAdmin(true);
        setBulkRole(userRole.GlobalAdmin);

        setFolderRoles(
            folderList.map(folder => ({
                folderId: folder.folderIdentifier,
                role: userRole.GlobalAdmin
            }))
        );

        return;
    }

    // const creatorRole = getCurrentFolderRole(folderId);

    // if (role !== 0 && role < creatorRole)
    //     role = creatorRole;

    setFolderRoles(prev =>
        prev.map(item =>
            item.folderId === folderId
                ? { ...item, role }
                : item
        )
    );
};
    // const handleBulkRoleChange = (role) => {
    //     if (role === 1) {
    //         setIsGlobalAdmin(true);
    //     }
    //     else {
    //         setIsGlobalAdmin(false);
    //     }

    //     setBulkRole(role);

    //     setFolderRoles(prev =>
    //         prev.map(folder => ({
    //             ...folder,
    //             role: role
    //         }))
    //     );

    // };
    const handleBulkRoleChange = (role) => {

        setIsGlobalAdmin(role === 1);

        setBulkRole(role);

        // setFolderRoles(prev =>
        //     prev.map(folder => {

        //         const creatorRole =
        //             getCurrentFolderRole(folder.folderId);

        //         let assignedRole = role;

        //         if (role !== 0 && role < creatorRole)
        //             assignedRole = creatorRole;

        //         return {
        //             ...folder,
        //             role: assignedRole
        //         };
        //     })
        // );
        setFolderRoles(prev =>
    prev.map(folder => ({
        ...folder,
        role
    }))
);
    };
    const handleSelectAll = () => {

        setFolderError(false);

        setFolderRoles(
            folderList.map(folder => ({
                folderId: folder.folderIdentifier,
                //role: bulkRole !== 0 ? bulkRole : roleSelection
                //role: bulkRole !== 0 ? bulkRole : 2
                //role: bulkRole !== 0 ? bulkRole : getCurrentUserRole()
                //role: bulkRole !== 0 ? bulkRole : getCurrentFolderRole(folder.folderIdentifier)
                role: bulkRole !== 0 ? bulkRole : 0
            }))
        );

    };

    const handleDeselectAll = () => {

        setFolderRoles([]);
        setSelectedFolders([]);

    };

    const [folderList, setFolderList] = React.useState([]);



    const breadcrumbItems = [
        { label: 'Home Page', url: '/' },
        { label: 'User Management', url: '/UserManagement' },
        { label: 'Edit User', url: '' },
    ];

useEffect(() => {
    const initializeUserAndFolders = async () => {
        try {
            // 1. Fetch ALL available folders first (Required for mapping)
            const rootResponse = await api.get("/Folders/getrootfolders?Id=" + userInfo.id);
            const allFolders = rootResponse.data.result.folders || [];
            setFolderList(allFolders);

            // 2. Fetch specific user access
            const accessResponse = await api.get("Folders?userId=" + userIdentifier);
            const userAccess = accessResponse.data.result;
            const backendIsGlobalAdmin = userAccess.isGlobalAdmin;

            setIsGlobalAdmin(backendIsGlobalAdmin);

            if (backendIsGlobalAdmin) {
                // If Global Admin, map all available folders to role 1 (Global Admin)
                // We use 'allFolders' directly here because state 'folderList' hasn't updated yet
                const adminMappings = allFolders.map(f => ({
                    folderId: f.folderIdentifier,
                    role: 1
                }));
                setFolderRoles(adminMappings);
                setBulkRole(1);
            } else {
                // If regular user, map their specific folder list
                const assignedFolders = userAccess.folderLists || [];
                
                setSelectedFolders(assignedFolders.map(x => x.folderIdentifier));
                setFolderRoles(
                    assignedFolders.map(x => ({
                        folderId: x.folderIdentifier,
                        role: Number(x.role) // Ensure number type for dropdown binding
                    }))
                );
            }
        } catch (error) {
            console.error('Error initializing Edit User data:', error);
            Swal.fire("Error", "Failed to load user access data", "error");
        }
    };

    if (userIdentifier && userInfo.id) {
        initializeUserAndFolders();
    }
}, [userIdentifier, userInfo.id]);

    const handleNameChange = (event) => {
        setName(event.target.value);
        setnameRequiredError(false);
        setNameRegexError(false);
        setSubBtnDisabled(false);
    };

    const handleInputChange = (fieldName, value) => {
        setFormErrors({ ...formErrors, [fieldName]: '' });

        if (fieldName === 'confirm') {
            setPasswordMatchError(false);
        }

        setFormValues({ ...formValues, [fieldName]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsFormSubmitted(true);
        setSubBtnDisabled(true)
        // Fetch form values
        const updatedName = name;
        const identifier = userIdentifier;

        if (name === '') {
            setnameRequiredError(true);
            setSubBtnDisabled(false);
            return;
        }

        if (name) {
            const regex = /^[a-zA-Z0-9' ]+$/;

            // Check if the entered username matches the pattern
            const isValid = regex.test(name);
            if (!isValid) {
                setNameRegexError(true);
                setSubBtnDisabled(false);
                return;
            }
        }
        // if (roleSelection !== userRole.GlobalAdmin && selectedFolders.length === 0) {
        //     setFolderError(true);
        //     setSubBtnDisabled(false);
        //     return;
        // }
        if (!isGlobalAdmin && folderRoles.length === 0) {
            setFolderError(true);
            setSubBtnDisabled(false);
            return;
        }
        try {
            const { data } = await api.put("/User/UpdateUserInfo", {
                name: updatedName,
                userid: identifier,
                //role: roleSelection,
                isGlobalAdmin: isGlobalAdmin,
                //folders: selectedFolders,
                folderRoles: folderRoles
            });
            if (data.statusCode === 200) {
                Swal.fire({
                    position: "center",
                    icon: "success",
                    text: "User updated successfully",
                    confirmButtonText: "Ok",
                    timer: 3000,
                    timerProgressBar: true
                }).then(val => {
                    if (val) {
                        navigate('/UserManagement');
                    }
                });;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        setSubBtnDisabled(false)
    };

    // const handleFolderSelection = (folder) => {
    //     setFolderError(false);
    //     // Add or remove the selected folder from the array
    //     setSelectedFolders((prevSelected) => {
    //         if (prevSelected.includes(folder)) {
    //             return prevSelected.filter((item) => item !== folder);
    //         } else {
    //             return [...prevSelected, folder];
    //         }
    //     });
    // };
    const handleFolderSelection = (folderIdentifier) => {

        setFolderError(false);

        const exists = folderRoles.find(x => x.folderId === folderIdentifier);

        if (exists) {

            setFolderRoles(prev =>
                prev.filter(x => x.folderId !== folderIdentifier)
            );

            setSelectedFolders(prev =>
                prev.filter(x => x !== folderIdentifier)
            );
        }
        else {

            setFolderRoles(prev => [
                ...prev,
                {
                    folderId: folderIdentifier,
                    //role: bulkRole !== 0 ? bulkRole : 2
                    //role: bulkRole !== 0 ? bulkRole : getCurrentUserRole()
                    //role: bulkRole !== 0 ? bulkRole : getCurrentFolderRole(folderIdentifier)
                    role: bulkRole !== 0 ? bulkRole : 0
                }
            ]);

            setSelectedFolders(prev => [
                ...prev,
                folderIdentifier
            ]);
        }
    };

    // const CheckAll = () => {
    //     if (selectedFolders.length === 0 && selectedFolders.length < folderList.length) {
    //         return true;
    //     }
    //     else if (selectedFolders.length < folderList.length) {
    //         return true;
    //     }
    //     else {
    //         return false;
    //     }
    //     setFolderError(false);
    // }

    // const handleSelectAllFolders = (e) => {
    //     setFolderError(false);
    //     if (e.target.checked) {
    //         // Select all folders
    //         setSelectedFolders(folderList.map(li => li.folderIdentifier));
    //     } else {
    //         // Deselect all folders
    //         setSelectedFolders([]);
    //     }
    // };

    // useEffect(() => {
    //     setSelectedDropdownItem(roleMapping[role]);
    //     setRoleSelection(role);
    //     setRole(role);
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [role]);

    return (
        <>
            <div className='right-content'>

                <BreadCrumb items={breadcrumbItems}></BreadCrumb>

                <div className='mid-box-wrap'>
                    <h4 className='sub-head'>Edit User</h4>
                    <form className='add-form' onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className='col-md-6 add-user-label'>
                                <div className="mb-2">
                                    <label htmlFor="name" className="form-label">Name</label>
                                    <input
                                        type="text"
                                        className={`form-control ${formErrors.name && 'error'}`}
                                        id="name"
                                        placeholder="Enter name"
                                        value={name}
                                        maxLength="200"
                                        onChange={handleNameChange}

                                    />
                                    {isFormSubmitted && formErrors.name && (
                                        <p className="error-message">{formErrors.name}</p>
                                    )}
                                    {nameRegexError && (
                                        <p className="error-message">* Name should be in valid format</p>
                                    )}
                                    {nameRequiredError && (
                                        <p className="error-message">* Name is required</p>
                                    )}
                                </div>
                                <div className="mb-2">
                                    <label htmlFor="id" className="form-label">User ID</label>
                                    <input
                                        type="text"
                                        className={`form-control ${formErrors.id && 'error'}`}
                                        id="id"
                                        placeholder="Enter User ID"
                                        maxLength="100"
                                        value={email} disabled
                                        onChange={(e) => handleInputChange('id', e.target.value)}
                                    />
                                    {isFormSubmitted && formErrors.id && (
                                        <p className="error-message">{formErrors.id}</p>
                                    )}
                                </div>
                            </div>

                            <div className='col-md-6 add-user-label'>



                                <div className="mb-2">
                                    <label htmlFor="password" className="form-label">Password</label>
                                    <input
                                        type="password"
                                        className={`form-control ${formErrors.password && 'error'}`}
                                        id="password"
                                        placeholder="Enter Password" disabled
                                        value={formValues.password}
                                        onChange={(e) => handleInputChange('password', e.target.value)}
                                    />
                                    {isFormSubmitted && formErrors.password && (
                                        <p className="error-message">{formErrors.password}</p>
                                    )}
                                    {passwordMatchError && (
                                        <p className="error-message">* Confirm Password does not match the Password</p>
                                    )}
                                </div>
                                <div className="mb-2">
                                    <label htmlFor="confirm" className="form-label">Confirm Password</label>
                                    <input
                                        type="text"
                                        className={`form-control ${formErrors.confirm && 'error'}`} disabled
                                        id="confirm"
                                        placeholder="Enter Confirm Password"
                                        value={formValues.confirm}
                                        onChange={(e) => handleInputChange('confirm', e.target.value)}
                                    />
                                    {isFormSubmitted && formErrors.confirm && (
                                        <p className="error-message">{formErrors.confirm}</p>
                                    )}
                                </div>

                            </div>

                            <div className='row mt-3'>
                                {/* <div className="mb-2">
                                    <label htmlFor="dropdownMenuButton1" className="form-label">Role</label>
                                    <div className="dropdown">
                                        <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                            {selectedDropdownItem}
                                        </button>
                                        
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            {visibleRoles.map((role) => (
                                                <li key={role.id} onClick={() => handleDropdownItemClick(role.id)}>
                                                    <span className="dropdown-item">{role.label}</span>
                                                </li>
                                            ))}
                                        </ul>

                                    </div>
                                    {isFormSubmitted && (formErrors.role || roleSelection === 'Select Role') && roleSelection !== 'Select Role' && (
                                        <p className="error-message">{formErrors.role}</p>
                                    )}
                                </div> */}

                                <div className="mb-2">




                                    <label class="form-label">Select Folder</label>
                                    <div className='select-folder'>
                                        <div className='folder-check-wrap'>
                                            <div className="d-flex justify-content-between align-items-center pb-3 mb-3">

                                                {/* Left Side */}
                                                <div className="d-flex align-items-center">

                                                    {/* Global Admin */}
                                                    <div className="form-check form-switch me-4 mb-0">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="globalAdminSwitch"
                                                            checked={isGlobalAdmin}
                                                            disabled={!user.isGlobalAdmin}
                                                            onChange={(e) => {
                                                                const checked = e.target.checked;
                                                                setIsGlobalAdmin(checked);
                                                                // if (checked) {
                                                                //     setBulkRole(1);
                                                                // } else {
                                                                //     setBulkRole(0);
                                                                // }
                                                                if (checked) {

                                                                    setBulkRole(1);

                                                                    setFolderRoles(

                                                                        folderList.map(folder => ({
                                                                            folderId: folder.folderIdentifier,
                                                                            role: userRole.GlobalAdmin
                                                                        }))

                                                                    );

                                                                }
                                                                else {

                                                                    setBulkRole(0);

                                                                    setFolderRoles([]);

                                                                }
                                                            }}
                                                        />

                                                        <label
                                                            className="form-check-label ms-2"
                                                            htmlFor="globalAdminSwitch"
                                                        >
                                                            Global Admin
                                                        </label>
                                                    </div>

                                                    {/* Divider */}
                                                    <div className="vr me-4"></div>

                                                    {/* Bulk Role */}
                                                    <div className="d-flex align-items-center">

                                                        <label className="me-2 mb-0 fw-semibold">
                                                            Bulk Role
                                                        </label>

                                                        <select
                                                            className="form-select"
                                                            disabled={isGlobalAdmin}
                                                            style={{ width: "220px" }}
                                                            value={bulkRole}
                                                            onChange={(e) =>
                                                                handleBulkRoleChange(Number(e.target.value))
                                                            }
                                                        >
                                                            <option value={0}>
                                                                Select Role
                                                            </option>

                                                            {bulkVisibleRoles.map(role => (
                                                                <option
                                                                    key={role.id}
                                                                    value={role.id}
                                                                >
                                                                    {role.label}
                                                                </option>
                                                            ))}
                                                        </select>

                                                    </div>

                                                </div>

                                                {/* Right Side */}
                                                <div>

                                                    <button
                                                        type="button"
                                                        disabled={isGlobalAdmin}
                                                        className="btn btn-outline-secondary btn-sm me-2"
                                                        onClick={handleSelectAll}
                                                    >
                                                        Select All
                                                    </button>

                                                    <button
                                                        type="button"
                                                        disabled={isGlobalAdmin}
                                                        className="btn btn-outline-secondary btn-sm"
                                                        onClick={handleDeselectAll}
                                                    >
                                                        Deselect All
                                                    </button>

                                                </div>

                                            </div>




                                            {/* <div className="form-check form-switch mt-3">

                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="globalAdminSwitch"
                                                    checked={isGlobalAdmin}
                                                    onChange={(e) => {

                                                        const checked = e.target.checked;
                                                        setIsGlobalAdmin(checked);
                                                        if (checked) {
                                                            setBulkRole(1);
                                                            setFolderRoles([]);
                                                            setSelectedFolders([]);
                                                        }
                                                        else {
                                                            setBulkRole(0);
                                                        }

                                                    }}
                                                />

                                                <label
                                                    className="form-check-label"
                                                    htmlFor="globalAdminSwitch"
                                                >
                                                    Global Admin
                                                </label>

                                            </div>
                                            <div className="mb-2">
                                                <label for="dropdownMenuButton1" class="form-label">Bulk Role</label>

                                                <select
                                                    className="form-control form-select"
                                                    value={bulkRole}
                                                    onChange={(e) => handleBulkRoleChange(Number(e.target.value))}
                                                >
                                                    <option value={0}>Select Bulk Role</option>

                                                    {visibleRoles.map(role => (
                                                        <option
                                                            key={role.id}
                                                            value={role.id}
                                                        >
                                                            {role.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div> */}
                                            {/* <div className="d-flex justify-content-end mb-3">

                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary btn-sm me-2"
                                                    onClick={handleSelectAll}

                                                >
                                                    Select All
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary btn-sm"
                                                    onClick={handleDeselectAll}
                                                >
                                                    Deselect All
                                                </button>

                                            </div> */}
                                            <div className="folder-header row fw-bold border-bottom pb-2 mb-2" style={{ background: '#f4f5f7', borderTop: '1px solid #d8d8d8', borderBottom: '1px solid #d8d8d8', padding: '10px 0', marginBottom: '0' }}>

                                                <div className="col-5">
                                                    Folder Name
                                                </div>

                                                <div className="col-3">
                                                    Assigned Role
                                                </div>

                                                <div className="col-4">
                                                    Access Summary
                                                </div>

                                            </div>

                                            {/* <div className='all-check'>
                                                <input type="checkbox" id='all' onChange={handleSelectAllFolders} checked={CheckAll() ? false : true} disabled={roleSelection === 1} /> <label for="all">Select All Folders</label>
                                            </div> */}
                                          {folderList.map((folder) => {
    // 1. Find the assigned role for this folder (Case-Insensitive check)
    const assignedRoleEntry = folderRoles.find(x => 
        x.folderId?.toLowerCase() === folder.folderIdentifier?.toLowerCase()
    );

    // 2. Determine if checkbox is checked
    const isChecked = !!assignedRoleEntry || isGlobalAdmin;

    // 3. Determine dropdown value
    // If Global Admin, force value to 1. Otherwise use assigned role or 0.
    const dropdownValue = isGlobalAdmin ? 1 : (assignedRoleEntry?.role ?? 0);

    return (
        <div className="row align-items-center single-check border-bottom py-2" key={folder.folderIdentifier}>
            <div className="col-5 d-flex align-items-center">
                <input
                    type="checkbox"
                    id={folder.folderIdentifier}
                    disabled={isGlobalAdmin}
                    checked={isChecked}
                    onChange={() => handleFolderSelection(folder.folderIdentifier)}
                />
                <label htmlFor={folder.folderIdentifier} className="ms-2 fw-semibold">
                    <img src="../Assets/folder-icon.svg" alt="folder" />
                    {" "} {folder.name}
                </label>
            </div>

            <div className="col-3">
                <select
                    className="form-select"
                    disabled={isGlobalAdmin || !isChecked}
                    value={dropdownValue}
                    onChange={(e) =>
                        handleFolderRoleChange(
                            folder.folderIdentifier,
                            Number(e.target.value)
                        )
                    }
                >
                    <option value={0}>Select Role</option>
                    {getVisibleRoles(folder.folderIdentifier).map(role => (
                        <option key={role.id} value={role.id}>
                            {role.label}
                        </option>
                    ))}
                </select>
            </div>

            <div className="col-4">
                <div className="small">
                    {getRoleSummary(dropdownValue)}
                </div>
            </div>
        </div>
    );
})}
                                        </div>
                                    </div>
                                    {selectFolderError && (
                                        <p className="error-message">* Please select at least one folder</p>
                                    )}

                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={handleclose}>
                                Cancel
                            </button>
                            <button className='btn btn-primary' disabled={subBtnDisabled} type='submit'>Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}